import { DataBean } from "../../DataBean";


export class HealthDiagnosisType extends DataBean {


    public async getHealthDiagnosisTypeCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthDiagnosisTypeCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}